import React, { useEffect, useState } from "react";
import * as Yup from "yup";
import { useTranslation } from "react-i18next"; // Import useTranslation hook
import { Link, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faTrash, faPen } from "@fortawesome/free-solid-svg-icons";
import HelmetInfo from "Components/HelmetInfo/HelmetInfo";
import ModalRequestAndAddProject from "Components/ModalRequestAndAddProject/ModalRequestAndAddProject";
import { toast } from "react-toastify";
import { collection, doc, getDocs, deleteDoc } from "firebase/firestore";
import { db } from "../../firebase"; // Adjust import path if necessary

const Languages = () => {
  const { t } = useTranslation(); // Initialize the useTranslation hook
  const [cards, setCards] = useState([]);
  const [showModal, setShowModalSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const router = useNavigate();

  // Fetch cards from Firestore
  const fetchCards = async () => {
    try {
      const collectionRef = collection(db, "languages", "languages", "Cards");
      const snapshot = await getDocs(collectionRef);
      const cardsData = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setCards(cardsData);
    } catch (error) {
      console.error("Error fetching cards:", error);
    }
  };

  // Handle card deletion
  const handleDeleteCard = async (cardId) => {
    try {
      const docRef = doc(db, "languages", "languages", "Cards", cardId);
      await deleteDoc(docRef);
      // Remove the deleted card from state
      setCards(cards.filter((card) => card.id !== cardId));
      toast.success(t("CardDeletedSuccessfully"), {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000,
      });
    } catch (error) {
      console.error("Error deleting card:", error);
      toast.error(t("CardDeletionFailed"), {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000,
      });
    }
  };

  // Fetch cards on component mount
  useEffect(() => {
    fetchCards();
  }, []);

  // Handle modal actions
  const handleCloseModal = () => {
    setShowModalSuccess(false);
    router("/home");
  };

  const handleOpenModalSuccess = () => {
    setShowModalSuccess(true);
  };

  return (
    <>
      <HelmetInfo titlePage={t("addNewProject")} />
      <ModalRequestAndAddProject
        showModal={showModal}
        handleCloseModal={handleCloseModal}
      />
      <div className="project-management-request all-main">
        <div className="d-flex justify-content-end">
          <li className="nav-item">
            <Link
              className="text-decoration-none d-flex align-items-center gap-2 btn-main button-home button-new-project"
              to={"/AddNewLangague"}
            >
              <FontAwesomeIcon icon={faPlus} />
              {t("add New language")}
            </Link>
          </li>
        </div>
        <div className="form-project-management">
          <div className="row Servcis-Cards">
            {cards.map((card) => (
              <div className="col-md-3 col-sm-6 mb-4" key={card.id}>
                <div className="service-card p-3">
              
                  <h5>{card.Name}</h5>
                  <p>
                    {card.Text}
                  </p>
                  <div className="d-flex gap-2">
                    <Link
                      className="btn btn-warning"
                      to={`/AddNewLangague?edit=${card.id}`}
                    >
                      <FontAwesomeIcon icon={faPen} />
                    </Link>
                    <button
                      className="btn btn-danger"
                      onClick={() => handleDeleteCard(card.id)}
                    >
                      <FontAwesomeIcon icon={faTrash} />
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default Languages;
